import { Address } from "viem";
import { TokenBalanceQueryOptions } from "./useTokenBalance";
import { useAddressesByNetwork } from "./useAddressesByNetwork";
import { useTokenBalance } from "./useTokenBalance";

export const useWethBalance = (address: Address, queryOptions?: TokenBalanceQueryOptions) => {
  const addressesByNetwork = useAddressesByNetwork();
  return useTokenBalance({ contractAddress: addressesByNetwork.WETH, address, queryOptions });
};
